"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterStoreSecretNames = void 0;
// names of the secret files in AWS parameter store (api keys saved in a separate enum - "ApiKeyIds")
var ParameterStoreSecretNames;
(function (ParameterStoreSecretNames) {
    ParameterStoreSecretNames["TikApi"] = "TikApi";
    ParameterStoreSecretNames["FacebookApp"] = "fb";
    ParameterStoreSecretNames["Twitch"] = "twitchSecret";
    ParameterStoreSecretNames["TipaltiKeys"] = "tipaltiKeys";
    ParameterStoreSecretNames["Shopify"] = "shopify";
    ParameterStoreSecretNames["ShopToken"] = "shopToken";
    ParameterStoreSecretNames["PaypalLive"] = "paypal_live";
    ParameterStoreSecretNames["PaypalDev"] = "paypal";
    ParameterStoreSecretNames["HelloSign"] = "helloSign";
    ParameterStoreSecretNames["Airtable"] = "airtable";
    ParameterStoreSecretNames["KlearDatabase"] = "db";
    ParameterStoreSecretNames["KlearSlackApp"] = "KlearSlackApp";
    ParameterStoreSecretNames["AccessKeyKlearOld"] = "accessKeyKlearOld";
    ParameterStoreSecretNames["GoogleLoggedInGuardTest"] = "googleLoggedInGuardTest";
    ParameterStoreSecretNames["GoogleSignin"] = "google_signin";
    ParameterStoreSecretNames["ExternalLogin"] = "external_login";
    ParameterStoreSecretNames["MeltwaterSearchApiKeyStaging"] = "meltwaterSearchApiKeyStaging";
    ParameterStoreSecretNames["MeltwaterSearchApiKeyProduction"] = "meltwaterSearchApiKeyProduction";
    ParameterStoreSecretNames["reCAPTCHA"] = "reCAPTCHA";
    ParameterStoreSecretNames["DatabusCa"] = "databus/ca.pem";
    ParameterStoreSecretNames["DatabusCertificate"] = "databus/certificate.pem";
    ParameterStoreSecretNames["DatabusPrivateKey"] = "databus/private-key.pem";
    ParameterStoreSecretNames["HapppyPrints"] = "HapppyPrintsAccount";
})(ParameterStoreSecretNames = exports.ParameterStoreSecretNames || (exports.ParameterStoreSecretNames = {}));
//# sourceMappingURL=parameterStoreSecretNames.enum.js.map